import type { WithFields, WithIncludes } from "@/api/jsonapi";
import type { Job as _Job } from "@/api/raptor";
import { isJsonapiHttpError, useGetOne } from "@mb-pro-ui/utils";

const fields = {
  jobs: [
    "created-ts",
    "accepted-ts",
    "started-ts",
    "arrived-ts",
    "state",
    "unit-statuses",
    "details",
    "values",
    "attachments",
    "log",
    "own-status",
    "customer-photos",
  ],
  "unit-statuses": ["state", "state-ts", "primary"],
  attachments: ["attachment-type", "created-ts", "user", "url", "own"],
  "job-log": ["text", "ts", "user"],
  units: ["name"],
} as const;

const include = {
  "unit-statuses": { unit: {} },
  "own-status": { unit: {} },
  attachments: {},
  log: {},
  "customer-photos": {},
} as const;

export type JobWithDetails = WithIncludes<
  WithFields<_Job, typeof fields>,
  typeof include
>;

export default function useJob(id: string) {
  return useGetOne<JobWithDetails>("raptor/jobs", id, {
    include,
    fields,
    retry(_, error) {
      if (
        isJsonapiHttpError(error) &&
        error.status === 404 &&
        error.data.errors[0]?.status === 404
      ) {
        return false; // Do not retry if the job is not found
      }
      return true;
    },
  });
}
